// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3pqoF","title":"AfterFrontImage_title__23zRI"};